<ng-container [ngSwitch]="status">
    <label class="status status-success"
           *ngSwitchCase="EventHistoryStatus.SUCCESS">
        <i class="fa fa-circle"></i><span [i18n]="[{target: 'innerHTML', key: 'webhooks-events.history-status.success'}]"></span>
    </label>
    <label class="status status-warning"
           *ngSwitchCase="EventHistoryStatus.IN_PROGRESS">
        <i class="fa fa-circle"></i><span [i18n]="[{target: 'innerHTML', key: 'webhooks-events.history-status.in-progress'}]"></span>
    </label>
    <label class="status status-danger"
           *ngSwitchCase="EventHistoryStatus.ERROR">
        <i class="fa fa-circle"></i><span [i18n]="[{target: 'innerHTML', key: 'webhooks-events.history-status.error'}]"></span>
    </label>
    <label class="status"
           *ngSwitchDefault>
        <i class="fa fa-circle"></i><span [i18n]="[{target: 'innerHTML', key: 'webhooks-events.history-status.unknown'}]"></span>
    </label>
</ng-container>
